module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms41e-detail-tab2"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS41EC2']['70']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.detailTab2Columns,
      "data": _vm.detailTab2,
      "searchDisp": false
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f5a1588!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms41e/detailTab2.vue
// module id = 3663
// module chunks = 1